import ArrowForwardIcon from "../../assets/icons/arrow_forward.svg?react";
import { cn } from "../../utils/classNames";
import useMarkDemandStudioOpened from "../../hooks/useMarkDemandStudioOpened";
import XLink from "../common/XLink";

const arrowClasses = "ml-auto h-action-arrow-h w-action-arrow-w flex-none";

// Appearance comes from the variant's aria-disabled rules; this only blocks interaction.
const disabledLinkClasses = "pointer-events-none opacity-100";

const LifecareStudioButton = ({ caseId, style, title = "Life Care Studio", disabled = false }) => {
  const markOpened = useMarkDemandStudioOpened(caseId);

  return (
    <XLink
      to={`/case/${caseId}/lifecare-studio`}
      variant="actionOutline"
      className={cn(disabled && disabledLinkClasses)}
      style={style}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      onClick={disabled ? undefined : markOpened}
    >
      <span>{title}</span>
      <ArrowForwardIcon className={arrowClasses} />
    </XLink>
  );
};

export default LifecareStudioButton;
